import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  name: "sale-order-info",
  class: "flex flex-1 flex-col p-2 md:px-5 md:py-4 relative"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = { class: "loading-card" }
const _hoisted_4 = { class: "loading-text" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row my-10 text-red-500 justify-center items-center"
}
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col relative"
}
const _hoisted_8 = { class: "so-header vp-card" }
const _hoisted_9 = { class: "so-header-controls flex items-center flex-wrap gap-y-1" }
const _hoisted_10 = { class: "so-name-couple flex items-center" }
const _hoisted_11 = { class: "so-actions-couple flex items-center gap-2 my-1" }
const _hoisted_12 = { class: "so-post-couple flex items-center gap-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "so-actions-menu" }
const _hoisted_15 = ["checked", "disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "so-facts" }
const _hoisted_18 = { class: "so-fact-label" }
const _hoisted_19 = { class: "so-fact-value" }
const _hoisted_20 = { class: "tabContainer tablesWrapper" }
const _hoisted_21 = {
  key: 0,
  class: "multiple-pricelists-banner"
}
const _hoisted_22 = { class: "banner-content" }
const _hoisted_23 = {
  key: 0,
  class: "mdi mdi-alert-circle-outline banner-icon"
}
const _hoisted_24 = {
  key: 1,
  class: "mdi mdi-check-circle-outline banner-icon"
}
const _hoisted_25 = { class: "banner-text" }
const _hoisted_26 = { class: "banner-message" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "banner-message" }
const _hoisted_29 = {
  key: 1,
  class: "flex flex-1 justify-center border border-gray-300"
}
const _hoisted_30 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_confirmation_modal = _resolveComponent("confirmation-modal")!
  const _component_MultiplePriceListSelector = _resolveComponent("MultiplePriceListSelector")!
  const _component_VuetifyDataTable = _resolveComponent("VuetifyDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loadingState.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "mdi mdi-refresh spin-animation loading-icon" }, null, -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString($setup.loadingState.message), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.saleOrderLinesData.error.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa-solid fa-circle-exclamation" }, null, -1)),
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.saleOrderLinesData.error), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "so-back-btn",
                  "aria-label": "Return to RFQs",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToRfqs && $setup.goToRfqs(...args)))
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "mdi mdi-chevron-left" }, null, -1)),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Return to RFQs")
                    ])),
                    _: 1
                  })
                ]),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "large",
                  "append-icon": "mdi-open-in-new",
                  class: "so-name-btn",
                  onClick: $options.openLink
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.saleOrderLinesData.saleOrder.name), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_AppSelect, {
                modelValue: $setup.saleOrderPricingStatus,
                onChange: $setup.onChangePricingStatus,
                options: $setup.saleOrderStatesSelectOptions.states
              }, null, 8, ["modelValue", "onChange", "options"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm so-refresh-btn gap-2 rounded-md normal-case",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onSaleLinesUpdate(false)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["mdi mdi-refresh", { 'spin-animation': $setup.loadingState.isLoading }])
                  }, null, 2),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "font-semibold" }, "Refresh", -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary gap-2 rounded-md normal-case text-white",
                    disabled: $setup.pricesNeeded > 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showConfirmationModal = true))
                  }, _cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "mdi mdi-share" }, null, -1),
                    _createElementVNode("span", { class: "font-semibold" }, "Post to Odoo", -1)
                  ]), 8, _hoisted_13),
                  _createVNode(_component_v_menu, {
                    modelValue: $setup.showActionsMenu,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.showActionsMenu) = $event)),
                    "close-on-content-click": false,
                    location: "bottom end",
                    offset: 4
                  }, {
                    activator: _withCtx(({ props: menuProps }) => [
                      _createElementVNode("button", _mergeProps(menuProps, {
                        type: "button",
                        class: "btn btn-sm so-actions-btn rounded-md",
                        "aria-label": "More actions"
                      }), _cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "mdi mdi-dots-vertical" }, null, -1)
                      ]), 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", {
                          class: _normalizeClass(["so-action-row", { 'so-action-row--busy': $setup.isUpdatingHistoryExclusion }])
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "so-action-text" }, [
                            _createElementVNode("span", { class: "so-action-label" }, "Skip SO from price suggestions"),
                            _createElementVNode("span", { class: "so-action-hint" }, " Keeps this order out of the history that suggests prices on future orders, but it stays searchable. ")
                          ], -1)),
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "toggle toggle-primary toggle-sm so-action-toggle",
                            checked: Boolean($setup.saleOrderLinesData.saleOrder.excludeFromHistory),
                            disabled: $setup.isUpdatingHistoryExclusion,
                            onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.onExcludeFromHistoryChange($event.target.checked)))
                          }, null, 40, _hoisted_15)
                        ], 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: "so-action-row so-action-row--action",
                          disabled: $setup.resettableLines.length === 0,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.onResetAllPricesClick && $setup.onResetAllPricesClick(...args)))
                        }, _cache[17] || (_cache[17] = [
                          _createElementVNode("span", { class: "so-action-text" }, [
                            _createElementVNode("span", { class: "so-action-label" }, "Reset all prices"),
                            _createElementVNode("span", { class: "so-action-hint" }, " Clears every price on this order, typed and calculated, and prices each line again from scratch. ")
                          ], -1)
                        ]), 8, _hoisted_16)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("div", {
              class: "so-header-divider",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.soFactsComputed, (fact) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "so-fact",
                  key: fact.label
                }, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(fact.label), 1),
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(fact.value) + " ", 1),
                    (fact.badge)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "top",
                          text: fact.badge.text
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props, {
                              size: "16",
                              class: "so-fact-badge",
                              icon: fact.badge.icon
                            }), null, 16, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["text"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          ($options.showConfirmationModalComputed)
            ? (_openBlock(), _createBlock(_component_confirmation_modal, {
                key: 0,
                message: $setup.postConfirmation.message,
                title: $setup.postConfirmation.title,
                confirmButtonText: $setup.postConfirmation.confirmText,
                cancelButtonText: $setup.postConfirmation.cancelText,
                onConfirm: $setup.onConfirmationModalEvents.confirm,
                onCancel: $setup.onConfirmationModalEvents.cancel
              }, null, 8, ["message", "title", "confirmButtonText", "cancelButtonText", "onConfirm", "onCancel"]))
            : _createCommentVNode("", true),
          ($setup.showUnlockConfirmationModal)
            ? (_openBlock(), _createBlock(_component_confirmation_modal, {
                key: 1,
                message: $data.unlockConfirmationMessage,
                title: $data.unlockConfirmationTitle,
                confirmButtonText: $data.unlockConfirmButtonText,
                cancelButtonText: $data.unlockCancelButtonText,
                onConfirm: $setup.onUnlockConfirmation.confirm,
                onCancel: $setup.onUnlockConfirmation.cancel
              }, null, 8, ["message", "title", "confirmButtonText", "cancelButtonText", "onConfirm", "onCancel"]))
            : _createCommentVNode("", true),
          ($setup.showResetPricesModal)
            ? (_openBlock(), _createBlock(_component_confirmation_modal, {
                key: 2,
                message: $setup.resetPricesConfirmation.message,
                title: $setup.resetPricesConfirmation.title,
                confirmButtonText: $setup.resetPricesConfirmation.confirmText,
                cancelButtonText: $setup.resetPricesConfirmation.cancelText,
                onConfirm: $setup.onResetAllPricesConfirmation.confirm,
                onCancel: $setup.onResetAllPricesConfirmation.cancel
              }, null, 8, ["message", "title", "confirmButtonText", "cancelButtonText", "onConfirm", "onCancel"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            ($setup.multiplePriceListIds.size > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    ($setup.pricesNeeded > 0)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                      : (_openBlock(), _createElementBlock("i", _hoisted_24)),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _createTextVNode(" There " + _toDisplayString($setup.saleLinesWithMultiplePriceLists.length === 1 ? 'is' : 'are') + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString($setup.saleLinesWithMultiplePriceLists.length), 1),
                        _createTextVNode(" sale line" + _toDisplayString($setup.saleLinesWithMultiplePriceLists.length === 1 ? '' : 's') + " with part numbers matching multiple pricelists ", 1),
                        ($setup.priceListNames.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _cache[19] || (_cache[19] = _createTextVNode(" (")),
                              _createElementVNode("strong", null, _toDisplayString($setup.priceListNames.join(', ')), 1),
                              _cache[20] || (_cache[20] = _createTextVNode("). "))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_28, [
                        _createElementVNode("strong", null, _toDisplayString($setup.pricesSelected), 1),
                        _cache[21] || (_cache[21] = _createTextVNode(" products out of ")),
                        _createElementVNode("strong", null, _toDisplayString($setup.saleLinesWithMultiplePriceLists.length), 1),
                        _createTextVNode(" " + _toDisplayString($setup.pricesSelected === 1 ? ' has' : 'have') + " been priced. ", 1)
                      ])
                    ])
                  ]),
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    size: "small",
                    class: "banner-btn",
                    onClick: $setup.onMultiplePricelistsBannerClick
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode(" Select Pricelists ")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_MultiplePriceListSelector, {
              modelValue: $setup.showPriceListSelector,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.showPriceListSelector) = $event)),
              saleLines: $setup.saleLinesWithMultiplePriceLists,
              availablePricelists: $setup.priceListNames,
              onConfirm: $setup.onPriceListSelectionConfirm,
              onCancel: _cache[7] || (_cache[7] = ($event: any) => ($setup.showPriceListSelector = false))
            }, null, 8, ["modelValue", "saleLines", "availablePricelists", "onConfirm"]),
            (!Object.keys($setup.saleOrderLinesData.data).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[23] || (_cache[23] = [
                  _createElementVNode("div", { class: "flex flex-row my-10 text-primary items-center" }, [
                    _createElementVNode("i", { class: "fa-solid fa-circle-exclamation" }),
                    _createElementVNode("p", { class: "ml-2" }, "No sale lines found!")
                  ], -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              ($setup.saleOrderLinesData?.data?.columnsDefs?.length && $setup.saleOrderLinesData?.data?.rowsData?.length)
                ? (_openBlock(), _createBlock(_component_VuetifyDataTable, {
                    key: 0,
                    class: "w-full",
                    domLayout: "autoHeight",
                    columnsDefs: $setup.visibleColumnsDefs,
                    rowsData: $setup.saleOrderLinesData.data.rowsData,
                    "update-row-fn": $options.wrappedUpdateSaleLine,
                    itemKey: 'partNumber',
                    "clickable-cell-href-fn": $setup.getSearchLineHref,
                    editableColumns: ['suggestedPrice', 'otherCosts', 'labor', 'notes'],
                    textareaColumns: ['notes'],
                    onUpdateItem: $options.handleUpdate,
                    onCellClicked: $setup.onCellClick,
                    onUnlockPrice: $setup.showUnlockPriceConfirmation,
                    onSelectPricelist: _cache[8] || (_cache[8] = ($event: any) => ($setup.showPriceListSelector = true))
                  }, null, 8, ["columnsDefs", "rowsData", "update-row-fn", "clickable-cell-href-fn", "onUpdateItem", "onCellClicked", "onUnlockPrice"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ]))
}